export default __webpack_public_path__ + "static/media/who-we-are-image.01affefd.jpg";